import React from 'react';

const IconLogo = () => (
 <img alt='logo' src="/logo.png"></img>
);

export default IconLogo;
